import React from 'react'

const StatusBoard = ({ palabras, instrucciones }) => {
  return (
    <div className="status-board">
        <p className='instrucciones'>{ instrucciones }</p>
        <ul>
            {palabras.map((palabra, index) => (
                <li key={index} >{ palabra }</li>
            ))}
        </ul>
    </div>
  )
}

export default StatusBoard